"use strict";
/**
 * Material Offer Record — Purchase links for public catalog materials
 *
 * Stored separately from the material display record to avoid fan-out updates
 * when purchase links change. One record per public material, direct PK/SK access.
 *
 * PK: public_material#{materialId}  (same partition as display#public)
 * SK: offers
 *
 * Query pattern: BatchGetItem with material display record (same partition)
 */
Object.defineProperty(exports, "__esModule", { value: true });
